import orderEnum from '../../enums/orderEnum';
import OrderCard from './orderCard';
import {Typography, Box, Container, Tabs, Tab} from '@mui/material';
import {useAppSelector} from '../../services/redux/store';
import { ReactElement, useState } from 'react';
import OrderHistoryItem from './orderHistoryItem';

const tabTitles = {
  all: 'همه',
  future: 'سفارش های آینده',
  past: 'سفارش های پیشین',
}
export default function Orders() {
  const [value, setValue] = useState(0);
  const [tab, setTab] = useState<string>(Object.keys(tabTitles).find(e => e == 'all'));
  const orders = [...useAppSelector((state) => state.orderReducer.orders)];
  const content = (): ReactElement[] => {
    return orders?.filter(order => {
      switch (tab){
        case 'future': return order.status == orderEnum.Status.Assigned
        case 'past': return order.status == orderEnum.Status.Done
        default: return true
      }
    }).map((order, index) =>
      <OrderHistoryItem order={order} key={index} />
    )
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        paddingTop: '70px',
        alignItems: 'center',
      }}
    >
      <Container sx={{px: '24px', display: 'flex', flexDirection: 'column', gap: 5}}>
        <Box component="section" sx={{display: 'flex', flexDirection: 'column', gap: 4}}>
           <div className='tabContainer'>
             {Object.entries(tabTitles).map(([key, value], index) =>
               <span className={'tabCell' + (tab == key ? ' selected' : '')} onClick={() => setTab(key)}>{value}</span>
             )}
           </div>
          {content()}
        </Box>
      </Container>
    </Box>
  );
}
